import React, { useCallback, useContext } from 'react';
import * as Styles from './AcademyPassFilterHandler.styles';
import { AcademyPassContext } from '@/contexts/academyPass/context';
import { filterHandlerLocale } from './AcademyPassFilterHandler.locale';
import { PageTitle } from 'gatorcomponents';

function AcademyPassFilterHandler({ filterTitle }) {
  const {
    filteredOptions,
    setFilteredOptions,
    clearFilter,
    filterTyped,
    setFilterTyped,
    setMultiSelectOptions,
    multiSelectOptions,
  } = useContext(AcademyPassContext);

  const handleMark = (chip) => {
    const newOptions = filteredOptions.map(option => ({
      ...option,
      checked: option.id === Number(chip.id),
    }));

    setFilteredOptions(newOptions);
  };

  const filterChips = filteredOptions.map((option, index) => ({
    ...option,
    onMark: () => handleMark(index),
  }));

  const selectProps = useCallback(() => {
    const chosenOptions = multiSelectOptions.filter(option => option.checked).map(option => option.label);

    const setValue = (value) => {
      const newOptions = multiSelectOptions.map(option => ({
        ...option,
        checked: option.label === value ? !option.checked : option.checked,
      }));

      setMultiSelectOptions(newOptions);
    };

    const concatOptions = chosenOptions.join(', ');

    return {
      options: multiSelectOptions,
      placeholder: filterHandlerLocale.multiSelectLabel,
      multiple: true,
      setValue,
      value: concatOptions,
      chosenOptions,
    };
  }, [multiSelectOptions, setMultiSelectOptions]);

  return (
    <Styles.FilterWrapper>
      <PageTitle
        testId="academy-pass-filter-handler"
        title={filterTitle && filterTitle}
        filterByPlaceholder={filterHandlerLocale.searchByCourseName}
        filterChips={filterChips}
        handleChangeFilterBy={setFilterTyped}
        filterByValue={filterTyped}
        handleClearFilter={clearFilter}
        handleChangeChip={handleMark}
        selectProps={selectProps()}
      />
    </Styles.FilterWrapper>
  );
}

export default AcademyPassFilterHandler;
